import type { FilmCard } from "../api/types";

export function sameDeck(a: readonly FilmCard[], b: readonly FilmCard[]): boolean {
  return a.length === b.length && a.every((card, i) => card.id === b[i]?.id);
}
